import React, { useState, useEffect } from 'react';
import "../App.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltV } from '@fortawesome/free-solid-svg-icons'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

import { grey } from '@mui/material/colors';
import { InputTextArea } from './textInputSKUExclusion';
import { Chip } from '@mui/material';
const tableHeadColour = grey[600];

//Material UI Styles
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: tableHeadColour,
        color: theme.palette.common.white,
        fontWeight: 600,
        cursor: 'pointer'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // '&:nth-of-type(odd)': {
    //   backgroundColor: theme.palette.action.hover,
    // },
    // hide last border
    // '&:last-child td, &:last-child th': {
    //   border: 0,
    // },
}));
//Material UI Styles

const initialColumns = [
    { id: 'business_unit_title', label: 'Business Unit', minWidth: 100, maxWidth: 200, align: 'center', is_sortable: true, is_sorted: false, sort_type: "asc", sort_name: "business_unit" },
    { id: 'ban_description', label: 'BAN Description', minWidth: 300, maxWidth: 400, align: 'center', is_sortable: true, is_sorted: false, sort_type: "asc", sort_name: "ban_description" },
    {
        id: 'ban_number',
        label: 'BAN Number',
        minWidth: 200,
        maxWidth: 200,
        align: 'center',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "ban_number",
        // format: (value) => value.toLocaleString('en-US'),
    },
    {
        id: 'action',
        label: '',
        minWidth: 200,
        maxWidth: 250,
        align: 'center',
        group: "other"
        // format: (value) => value.toFixed(2),
    },
   
];

const TableSKUBestPerforming = (props) => {

    const [columns, setColumns] = React.useState(initialColumns);

    const handleBanPopupModal = (id = null, selectedBU="") => {
        props.handleBanPopupModal(id, selectedBU)
    }

    const handleSorting = (column) => {
        if (column.is_sortable) {
            var newData = []
            var data = columns
            let sort_type = "asc"
            if (column.is_sorted) {
                sort_type = column.sort_type === "asc" ? "desc" : "asc"
            }
            data.map(ele => {
                if (ele.id == column.id) {
                    newData.push({
                        ...ele,
                        is_sorted: true,
                        sort_type: sort_type,
                    })
                } else {
                    newData.push({
                        ...ele,
                        is_sorted: false,
                        sort_type: sort_type,
                    })
                }
            })
            props.handleSorting(newData);
            setColumns(newData);
        }
    }

    const getSortButton = (sortType) => {
        if (sortType === "asc") {
            return <FontAwesomeIcon icon={faArrowsAltV} className="sort-button" size="1x" title="Ascending" />
        } else if (sortType === "desc") {
            return <FontAwesomeIcon icon={faArrowsAltV} className="sort-button" size="1x" title="Descending" />
        }
    }

    const updateChangedSKUBestPerforming = (sku_id, updatedElement) => {
        // var data = changedSKUExclusions
        var dataObjects = props.changedSKUBestPerformingObjects

        var is_object_present = dataObjects.find(obj => {
            return obj.id === sku_id
        })

        if (is_object_present != undefined) {
            
                var removeIndex = dataObjects.findIndex(function (i) { return i.id === updatedElement.id });
                dataObjects.splice(removeIndex, 1);
                
    }
            
        else {
            // data.push(sku_id)
            dataObjects.push(updatedElement)
        }
        props.updateChangedSKUBestPerforming(dataObjects);
    }

    //Dropdown Handler As Parent Component
    const setBestPerformingValues = (sku_id) => {
        //Assigning New Value On Change In Dropdown
        var newData = []
        var data = props.skuPerformanceList
        var updatedElement = {}

        data.map(ele => {
            if (ele.id === sku_id) {
                updatedElement = {
                    ...ele,
                }
                newData.push(updatedElement)
                updateChangedSKUBestPerforming(sku_id, updatedElement);
            } else {
                newData.push(ele)
            }
        })
        props.setBestPerformingValues(newData);
    }

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <StyledTableRow className="bold-font">
                            {columns.map((column) => (
                                <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, width: column.maxWidth }}
                                    title="Click and wait to Sort"
                                    onClick={() => handleSorting(column)}
                                >
                                    {column.label}
                                    {/* Sort Icon Handled */}
                                    {column.is_sortable ?
                                        getSortButton(column.sort_type) :
                                        ""}
                                    {/* Sort Icon Handled */}
                                </StyledTableCell>
                            ))}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {props.skuPerformanceList
                            .map((row) => {
                                return (
                                    <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <StyledTableCell key={column.id} align={column.align} title={value}>
                                                    {column.id === "ban_number" ?
                                                                    <div className="sku-exclusion-list-comment-column" onClick={() => handleBanPopupModal(value, row.business_unit_id)} style={{ cursor: 'pointer' }} >
                                                                        <p style={{ color: "Blue" }} >{value}</p>
                                                                    </div>
                                                                    : column.id === "action" ? <Chip onClick={()=>setBestPerformingValues(row.id)} className="sku-delist-button" color="error" label="Delist" 
                                                                    variant={props.changedSKUBestPerformingObjects.find(obj => {return obj.id === row.id}) ? "contained":"outlined"} /> 
                                                                : value}
                                                </StyledTableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                );
                            }
                            )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default TableSKUBestPerforming;